import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { HttpErrorsToIgnore } from "../helpers/http-errors-to-ignore.helper";
import { LogBuilderService } from "../services/local/log-builder.service";
import { LogService } from "../services/log.service";

@Injectable()

export class GlobalErrorHandler implements ErrorHandler {
  private previousErrors: string[] = [];

  constructor(
    private _logBuilderService: LogBuilderService,
    private _logService: LogService
  ) { }


  handleError(error: any) {
    if (error) {
      // Checks on the error
      const isErrorToIgnore = error instanceof HttpErrorResponse &&
        HttpErrorsToIgnore.includes(error.status);
      const isPreviousError = this.previousErrors.includes(error);

      // stop flooding the logs with loops and ignored Errors.
      if (!(isErrorToIgnore || isPreviousError)) {
        const currentError = error.toString();
        error.message = error.message || 'Undefined client error';
        const newErrorLog = this._logBuilderService.build(error);
        this._logService.insert(newErrorLog).subscribe();
        this.previousErrors.push(currentError);
      }
      throw error;
    }
  }

}
